import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './AddList.module.scss';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Input from 'Flow2/components/UI/Input/Input';
import Button from 'Flow2/components/UI/Button/Button';
import iconDelete from 'PMDB/assets/images/png_icons/cancel_icon_black.png';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AddListRow = (props) => {
    let delIcon = "";
    let editIcon = "";
    let element = "";
    
    if(props.canRemove) {
        delIcon = (<span><img alt="" className="pointer" onClick={props.remove} src={iconDelete} /></span>);
    }
    
    if(props.canRemove) {
        editIcon = (<span><FontAwesomeIcon icon="pen" className="pointer" onClick={props.click} /></span>);
    }
    
    if(props.element.href && props.element.href.indexOf('http') !== -1) {
        element = (<a href={props.element.href} title={props.element.href} target="_blank" rel="noopener noreferrer">{props.element.title}</a>);
    } else {
        element = props.element.title;
    }
    
     return (<FlexRow  className={[classes.Row, classes[props.canRemove]].join(' ')}>
                    <span className={classes.RowData}>{element}</span>
					{editIcon}
                    {delIcon}
                </FlexRow>);
}

const AddListInput = (props) => {
    if(!props.showInput) {
        return "";
    }
    
    return (
        <FlexColumn>
            <FlexRow className={[classes.Input, 'relative'].join(' ')}>
                <Input
                    value={props.element.href}
                    elementConfig={{type: 'text', placeholder:"url"}}
                    changed={(event) => { props.changed({ ...props.element, href: event.target.value }) }}/>
            </FlexRow>
            <FlexRow className={[classes.Input, 'relative'].join(' ')}>
                <Input
                    value={props.element.title}
                    elementConfig={{type: 'text', placeholder:"title"}}
                    changed={(event) => { props.changed({ ...props.element, title: event.target.value }) }}/>
            </FlexRow>
            <FlexRow className={[classes.Control, 'relative'].join(' ')}>
            
                <Button btnType="Red" clicked={props.add}><FormattedMessage id="common.add" /></Button>
					{/*<Button btnType="White" clicked={props.clear}><FormattedMessage id="common.cancel" /></Button>*/}
            </FlexRow>
        </FlexColumn>
           );
}

class LinkAddList extends React.Component {
    
    constructor(props){
		super(props);
		this.state = {
            index: -1,
            data: props.data || "",
            showList: props.showList || true,
            showInput: props.add ? true : false,
            canRemove: props.remove ? true : false
		};
        
		this.state.element = this.createNewElement();
        this.state.elements = LinkAddList.createElements(props.data);
    }
    
    static createElements(data) {
        let elements = this.splitData(data);
        const list = [];
        
        elements.forEach(id => {
            let text = "";
            let href = id.match(/href="([^'"]*)/g);
            
            if(href) {
                href = href[0];
                href = href.replace(/href="/, '');
                
                text = id.match(/>(.*?)</g);
                text = text[0];
                text = text.replace(/>|</g, '');
                
                if(href.indexOf('http') === -1) {
                    text = href;
                    href = "";
                } else if(!text) {
                    text = href;
                }
            } else {
                text = id;
            }
            
            if(text) {
                list.push({ href: href, title: text });
            }
        });
        
        return list;
    }
    
    static splitData(data) {
        if(typeof data === 'string') {
            let value = data;
            if(value) {
                //value = value.replace(/,$/g, "");
                value = value.replace(/\n$/g, "");
                //value = value.replace(/\ /g, "");
                /*while(value.match(/,,/)) {
                    value = value.replace(/,,/g, ",");
                }*/
                while(value.match(/\n\n/)) {
                    value = value.replace(/\n\n/g, "\n");
                }
            }
            //return value.split(',');
            return value.split('\n');
        }
        
        return [];
    }
    
    createNewElement = () => {
        return {
                href: "",
                title: ""
            };
    }
    
    onChangedHandler = (element) => {
        this.setState({ element: element });
    }
    
    onSelect = (element, index) => {
        if(!element.href && !element.title) {
            return;
        }
        
        if(element.href) {
            if(element.href.indexOf('http') === -1) {
                element.title = element.href
                element.href = "";
            } else if(!element.title) {
                element.title = element.href;
            }
        }
        
        const elements = this.state.elements;
        if(index > -1) {
            elements[index] = element;
        } else {
            elements.push(element);
        }
        
        this.setState({ element: this.createNewElement(), elements: elements, index: -1 });
		this.save(elements);
    }
    
    save = (elements) => {
        const save = [];
        elements.forEach((element) => {
            if(element.href) {
                save.push('<a href="'+element.href+'">'+element.title+'</a>');
            } else {
               save.push(element.title); 
            }
        });
        //this.props.add(save.join(','));
        this.props.add(save.join('\n'));
    }
    
    onRemoveClick = (index) => {
        const elements = this.state.elements;
        elements.splice(index, 1);
        this.setState({ element: this.createNewElement(), elements: elements, index: -1 });
        this.save(elements);
    }
    
    onRowClick = (element, index) => {
        this.setState({element: element, index: index});
    }
    
    onClearInput = () => {
        this.setState({ element: this.createNewElement(), index: -1 });
    }
    
    createList = () => {
        if(!this.state.showList) {
            return "";
        }
        
        return this.createRowList();
    }
    
    createRowList = () => {
        const rows = this.state.elements.map((element, index) => {
            return (
                <AddListRow
                    key={element.id}
                    element={element}
                    click={() => {this.onRowClick(element, index)}}
                    remove={() => this.onRemoveClick(index)}
                    canRemove={this.state.canRemove} />
            );
        });
        
        return (
            <FlexColumn className={classes.List}>
                {rows}
            </FlexColumn>
        );
    }
    
    render = () => {
        const input = (<AddListInput
                            id={this.props.id}
                            config={this.props.config}
                            history={this.props.history}
                            showInput={this.state.showInput}
                            element={this.state.element}
                            changed={( element ) => this.onChangedHandler( element )}
                            clear={this.onClearInput}
                            add={() => {this.onSelect(this.state.element, this.state.index)}} />);
        
        return (
            <FlexColumn className={classes.AddList}>
                { this.createList() }
                {input}
            </FlexColumn>
        );
    }
    
    static getDerivedStateFromProps(nextProps, prevState) {
        if(prevState) {
            return {
                input: nextProps.add ? prevState.input : "",
                data: nextProps.data || "",
                showList: nextProps.showList || true,
                showInput: (nextProps.add && true) || false,
                canRemove: (nextProps.remove && true) || false,
                elements: LinkAddList.createElements(nextProps.data)
            }; 
        }
        
        return null;
    }
    
};

const mapStateToProps = (state, ownProps) => {
    return {
        config: state.ui.config
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LinkAddList));
